// Les briefs : le brief du lundi d'un dossier (V4MondayBrief) et le brief en
// sept sections d'une marque (V4Brief).
export default {
  lundi: {
    titre: 'Brief du lundi',
    erreur: 'Brief illisible',
    // Une phrase citée, avec les guillemets de la langue.
    citation: '« {texte} »',
    choisir: 'Choisissez un dossier',
    enCours: '(en cours)',
    semaine: {
      courante: 'Cette semaine (en cours)',
      du: 'Semaine du {debut} au {fin}',
      courte: 'Semaine du {date}',
      sorties: '{semaine} · {n}',
      vide: '{semaine} · vide',
      precedente: 'Semaine précédente',
      suivante: 'Semaine suivante',
    },
    mouvement: {
      nouveau: 'nouveau',
      monte: 'monte',
      stable: 'tient',
      recule: 'recule',
    },
    sansDossier: 'Le brief du lundi se lit par dossier : choisissez-en un dans la barre de gauche. Il rassemble ce que la patrouille d’Orion a vu sur ses territoires et ce que les ISOs de ses marques ont rapporté.',
    legende: {
      patrouille: 'patrouille d’Orion',
      arene: 'Arène',
      grille: 'Grille',
    },
    recalculerAide: 'Recalculer la restitution des marques pour cette semaine',
    recalculer: 'recalculer',
    rassemblement: 'Rassemblement de la semaine…',
    essentiel: 'L’essentiel de la semaine',
    territoires: {
      titre: 'Vos territoires, vus par Orion',
      sousTitre: 'ce vers quoi leur audience va d’elle-même',
      aucun: 'Pas encore de territoire : ils remontent des marques dès qu’un audit les détecte.',
      principal: 'principal',
      aucuneSortie: 'aucune sortie cette semaine',
      rienQuiSeDetache: 'rien qui se détache',
      eclaireurs: '{n} écl.',
      monteAussi: 'monte aussi',
      tient: 'tient',
      recule: 'recule',
      devraitMonter: 'devrait encore monter',
      projete: 'Niveau projeté dans sept jours, au rythme actuel : {avant} → {apres}, confiance {pct} %',
      revoir: 'Un sujet doit être revu plusieurs jours pour compter.',
    },
    traverse: {
      titre: 'Ce qui traverse vos territoires',
      reduire: 'réduire',
      voirTout: 'voir les {n}',
    },
    marque: {
      vu: 'ce que ses ISOs ont vu',
      carte: 'la carte des ISOs →',
      aucuneFlotte: 'Aucune flotte n’est sortie cette semaine : sans l’Arène, on ne sait pas où la marque est, donc pas où elle manque.',
      activer: 'Activer les ISOs du dossier →',
      pasSortie: 'pas sortie',
      sorties: '{n} sorties',
      percu: 'perçu vs attendu',
      espacesBlancs: 'espaces blancs · à trancher au Bureau',
      jours: '{n} jours · {ou}',
      demande: 'Faut-il que {marque} prenne la parole sur « {sujet} » ? Son audience y va depuis {jours} jours, et la marque n’y est pas.',
      tester: 'tester →',
      masquerMots: 'masquer leurs mots',
      voirMots: 'ce qui monte chez ses ISOs, avec leurs mots ({n})',
      isos: '· {isos} ISOs, {terr} terr.',
      cliquent: 'ils cliquent pour',
      lasse: 'lasse',
    },
    predictions: {
      titre: 'Les prédictions',
      aVenir: 'À venir · 4 semaines',
      aucunRendezVous: 'Aucun rendez-vous daté, avec une simulation, dans le domaine du dossier. L’actualité générale d’un pays n’y figure pas.',
      simulation: 'simulation :',
      aRelire: 'À relire · le jour est passé',
      aRelireTexte: 'Une simulation datée dont personne n’a noté le réel. C’est en la confrontant qu’on sait ce que vaut l’instrument.',
      rienEnAttente: 'Rien en attente.',
      lectures: 'Les simulations posées sur les sujets qui montent',
    },
    decisions: {
      titre: 'Décisions ouvertes',
      registre: '{n} prédiction(s) du registre attendent leur réel',
      plusieursMarques: 'plusieurs marques',
    },
    bureau: {
      titre: 'À ouvrir au Bureau d’études',
      ouvrir: 'Ouvrir une étude',
    },
    pied: 'Tout est compté sur ce que les ISOs ont rapporté - ceux d’Orion et ceux de la marque, individus synthétiques calibrés sur des audiences mesurées. Rien n’y est rédigé par un modèle, et la synthèse des territoires n’y figure pas.',
  },

  // ── Le brief en sept sections d'une marque ────────────────────────────────
  sept: {
    titre: 'Brief',
    titreTerritoire: 'Brief - {territoire}',
    sousTitre: '{marque} · 7 sections',
    erreur: {
      generation: 'Génération impossible',
      blast: 'Envoi en BLAST impossible',
    },
    production: {
      concept: 'Concept',
      format: 'Format',
      angle: 'Angle',
      ton: 'Ton',
      timing: 'Timing',
    },
    territoire: {
      position: 'position sur la carte',
      espaceLibre: 'espace libre',
      recouvrement: 'recouvrement',
    },
    persona: {
      part: 'part {n}%',
      confiance: 'confiance {n}%',
    },
    dashboard: 'Dashboard',
    verrouillee: 'Structure verrouillée ·',
    recentes: 'données récentes',
    aideRegenerer: 'Régénère le brief depuis le dernier audit',
    aideGenerer: 'Génère le brief depuis le white space, les personas et le score de marque',
    generation: 'Génération…',
    regenerer: 'Régénérer',
    generer: 'Générer le brief',
    aideBlast: 'Crée une campagne BLAST avec un plan de test à variable isolée dérivé de ce brief',
    creation: 'Création…',
    envoyerBlast: 'Envoyer en BLAST',
    chargement: 'Chargement…',
    aucun: 'Aucun brief pour cette marque',
    aucunTexte: "Le brief se construit sur le territoire détecté (white space), les personas et le Brand Strength Score. Lancez d'abord une analyse complète si ce n'est pas fait, puis générez.",
    section: {
      decision: 'La décision',
      signal: 'Signal',
      territoire: 'Territoire',
      persona: 'Validation persona',
      production: "Ce qu'on produit",
      gardeFous: 'Garde-fous',
      mesure: 'Comment on mesure',
    },
    signal: {
      territoire: 'territoire',
      force: 'force (score white space)',
      velocite: 'vélocité / 30 j',
    },
    voirCarte: 'voir sur la carte →',
    core: 'Core',
    emerging: 'Emerging cible',
    aValider: 'à valider',
    kanban: 'Voir le kanban',
  },
}
